
// CURSOR (desktop only)
if(window.matchMedia('(min-width:1025px)').matches){
  const cursor=document.getElementById('cursor'),ring=document.getElementById('cursorRing');
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;cursor.style.transform=`translate(${mx-6}px,${my-6}px)`;});
  function animRing(){rx+=(mx-rx)*.12;ry+=(my-ry)*.12;ring.style.transform=`translate(${rx-18}px,${ry-18}px)`;requestAnimationFrame(animRing);}
  animRing();
  document.querySelectorAll('a,button,.page-link,.pillar,.hcard,.prod-card,.retail-card,.rk-card').forEach(el=>{
    el.addEventListener('mouseenter',()=>{cursor.style.background='var(--clay)';});
    el.addEventListener('mouseleave',()=>{cursor.style.background='var(--fern)';});
  });
}

// PAGE ROUTER
function goTo(pageId){
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));
  const target=document.getElementById('page-'+pageId);
  if(target) target.classList.add('active');
  document.querySelectorAll('.nav-link').forEach(l=>l.classList.remove('active'));
  const active=document.querySelector(`.nav-link[data-page="${pageId}"]`);
  if(active) active.classList.add('active');
  window.scrollTo({top:0,behavior:'smooth'});
}
document.querySelectorAll('.page-link').forEach(el=>{
  el.addEventListener('click',function(e){
    const p=this.getAttribute('data-page');
    if(p){e.preventDefault();goTo(p);}
  });
});

// CART
let cartCount=0;
function addToCart(){
  cartCount++;
  document.getElementById('cartCount').textContent=cartCount;
  const t=document.getElementById('cartToast');
  t.classList.add('show');
  setTimeout(()=>t.classList.remove('show'),2400);
}
function showCart(){
  alert(`🛒 You have ${cartCount} item${cartCount!==1?'s':''} in your cart.\n\nVisit itpcinc.com to complete your purchase!`);
}

// FAQ
function toggleFaq(el){
  const wasOpen=el.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i=>i.classList.remove('open'));
  if(!wasOpen) el.classList.add('open');
}

// FILTER TAGS
document.querySelectorAll('.ftag').forEach(tag=>{
  tag.addEventListener('click',function(){
    this.closest('.filter-tags').querySelectorAll('.ftag').forEach(t=>t.classList.remove('active'));
    this.classList.add('active');
  });
});

// PRODUCT PAGE INTERACTIONS
function setMainImg(thumb,emoji){
  document.querySelectorAll('#page-product .pdp-thumb').forEach(t=>t.classList.remove('active'));
  thumb.classList.add('active');
  const main=document.getElementById('pdp-main-img');
  if(main) main.textContent=emoji;
}
function setWaterMainImg(thumb,emoji){
  document.querySelectorAll('#page-product-water .pdp-thumb').forEach(t=>t.classList.remove('active'));
  thumb.classList.add('active');
  const main=document.getElementById('pdp-water-main-img');
  if(main) main.textContent=emoji;
}
function selectColor(el){
  document.querySelectorAll('.pdp-color').forEach(c=>c.classList.remove('active'));
  el.classList.add('active');
  const lbl=document.getElementById('selected-color');
  if(lbl) lbl.textContent=el.getAttribute('data-color');
}
function selectSize(el){
  el.parentElement.querySelectorAll('.pdp-size').forEach(s=>s.classList.remove('active'));
  el.classList.add('active');
}
function selectWaterBundle(el,name){
  el.parentElement.querySelectorAll('.pdp-size').forEach(s=>s.classList.remove('active'));
  el.classList.add('active');
  const lbl=document.getElementById('selected-water-bundle');
  if(lbl) lbl.textContent=name;
}
// Cup page interactions
function setCupMainImg(thumb,emoji){
  document.querySelectorAll('#page-product-cup .pdp-thumb').forEach(t=>t.classList.remove('active'));
  thumb.classList.add('active');
  const main=document.getElementById('pdp-cup-main-img');
  if(main) main.textContent=emoji;
}
function selectCupStyle(el,name){
  el.parentElement.querySelectorAll('.pdp-size').forEach(s=>s.classList.remove('active'));
  el.classList.add('active');
  const lbl=document.getElementById('selected-cup-style');
  if(lbl) lbl.textContent=name;
}
function changeCupQty(delta){
  const input=document.getElementById('pdp-cup-qty-input');
  if(!input) return;
  let val=parseInt(input.value)||1;
  val=Math.max(1,Math.min(99,val+delta));
  input.value=val;
}
function changeQty(delta){
  const input=document.getElementById('pdp-qty-input');
  if(!input) return;
  let val=parseInt(input.value)||1;
  val=Math.max(1,Math.min(99,val+delta));
  input.value=val;
}
function changeWaterQty(delta){
  const input=document.getElementById('pdp-water-qty-input');
  if(!input) return;
  let val=parseInt(input.value)||1;
  val=Math.max(1,Math.min(99,val+delta));
  input.value=val;
}
function switchTab(btn,tabId){
  // Only switch tabs within the same tab group
  const tabsContainer=btn.closest('.pdp-details-tabs');
  const contentContainer=tabsContainer.parentElement;
  contentContainer.querySelectorAll('.pdp-tab').forEach(t=>t.classList.remove('active'));
  contentContainer.querySelectorAll('.pdp-tab-content').forEach(c=>c.classList.remove('active'));
  btn.classList.add('active');
  const target=document.getElementById(tabId);
  if(target) target.classList.add('active');
}

// Bundle tabs (separate from product detail tabs)
function switchBundleTab(btn, tabId, containerId) {
  // Deactivate all sibling tab buttons
  var tabRow = btn.parentElement;
  var tabs = tabRow.querySelectorAll('.bundle-tab');
  for (var i = 0; i < tabs.length; i++) tabs[i].classList.remove('active');
  btn.classList.add('active');
  // Use explicit container if provided, else use tabRow parent
  var container = containerId
    ? document.getElementById(containerId)
    : tabRow.parentElement;
  if (!container) return;
  // Hide all tab contents in this container
  var contents = container.querySelectorAll('.bundle-tab-content');
  for (var i = 0; i < contents.length; i++) contents[i].classList.remove('active');
  // Show the target
  var target = document.getElementById(tabId);
  if (target) target.classList.add('active');
}

// Make shop product cards open the right product page based on category
document.querySelectorAll('.shop-products-grid .prod-card, .prod-grid .prod-card').forEach(card=>{
  card.addEventListener('click',function(e){
    if(e.target.classList.contains('add-to-cart')) return;
    const cat=card.querySelector('.prod-cat');
    const catText=cat?cat.textContent.toLowerCase():'';
    if(catText.includes('filter')||catText.includes('water')){
      goTo('product-water');
    }else if(catText.includes('cup')){
      goTo('product-cup');
    }else{
      goTo('product');
    }
  });
});

// -- PRODUCT DATABASE --------------------------------------------------
var allProducts = {
  'gallon-bag': {
    title:'Gallon Silicone Storage Bag', cat:'Silicone Bags', price:'$18.99', was:'$24.99', save:'Save 24%',
    rating:'4.9', reviews:'2,847', img:'🥗', template:'bag',
    desc:'Tired of plastic bags that harm the environment? Our Gallon Innovative Bag is made from pure platinum-cured silicone -- plastic-free, odorless, flavorless, and built to last 20+ years. With storage date markings on the front, braille measurements for the visually impaired, and a patented one-hand opening. Fits a whole 7 lb chicken. Rated (E) for Everyone.',
    capacity:'1 US Gallon / 3.78 Liters (up to 4 liters) | Fits a whole 7 lb chicken or up to 10 lbs', dimensions:'H: 10.5in x L: 12in x W: 2.5in (26.67cm x 30.48cm x 6.35cm)', weight:'0.78 lbs / 12.6 oz / 355 grams', temp:'Freezer to 400F',
    colors:'Light Pink, Light Lemon Yellow, Light Baby Blue',
    features:['Platinum-Cured Food-Grade Silicone -- 100% plastic-free, odorless, flavorless, 20+ year lifespan','Built-In Date Markings -- track frozen items storage dates on the front of the bag','Braille Measurements -- printed on measurement side for visually impaired users','Patented One-Hand Opening -- easy secure seal for people with hand disabilities','Two Sturdy Handles -- stands upright for easy filling and organized storage','Temperature Range: Freezer to 400F -- freeze, microwave, oven, sous-vide, pressure cooker','Cooks a Whole Chicken -- fits a 7 lb chicken or pot roast, up to 10 lbs','Eco-Friendly -- replace hundreds of single-use plastic bags every year'],
    care:'Dishwasher safe top rack or hand-wash with warm soapy water. Turn inside-out for deep cleaning. For strong odors soak in warm water with 2 tbsp baking soda 30 minutes. No sharp utensils. No open flame. No bleach.'
  },
  'half-gallon-bag': {
    title:'Half Gallon Silicone Storage Bag', cat:'Silicone Bags', price:'$15.99', was:'$19.99', save:'Save 20%',
    rating:'4.9', reviews:'1,924', img:'🍱', template:'bag',
    desc:'Same lifetime quality as our gallon bag in the perfect smaller portion size. Pure platinum-cured silicone -- plastic-free, odorless, flavorless. Ideal for cereals, fruits, dry nuts, rice, cookies, breads, and everyday leftovers. Holds 7 lbs of grains or 5 lbs of fruits. Features date markings, braille, and patented one-hand opening. Built to last 20+ years.',
    capacity:'2 Liters / Half Gallon | Grains: 7 lbs / 112 oz / 24.5 cups | Fruits: 5 lbs / 80 oz / 17.5 cups', dimensions:'H: 9.0in x L: 10.0in x W: 2.0in (22.86cm x 25.4cm x 5.08cm)', weight:'0.47 lbs / 7.4 oz / 215 grams', temp:'Freezer to 400F',
    colors:'Clear, Light Lemon Yellow, Light Pink, Light Baby Blue',
    features:['Platinum-Cured Food-Grade Silicone -- 100% plastic-free, odorless, flavorless, 20+ year lifespan','Built-In Date Markings -- track storage dates directly on the bag','Braille Measurements -- accessible for visually impaired users','Patented One-Hand Opening -- easy for everyone including those with hand disabilities','Two Sturdy Handles -- stands upright for easy filling','Temperature Range: Freezer to 400F -- freeze, microwave, oven, sous-vide, pressure cook','Holds 2 Liters -- perfect for cereals, fruits, dry nuts, rice, cookies and breads','Capacity: 7 lbs grains or 5 lbs fruits -- generous everyday storage'],
    care:'Dishwasher safe top rack or hand-wash with warm soapy water. Turn inside-out for deep cleaning. Store flat or rolled. Avoid sharp utensils and open flame.'
  },
  'snack-bag': {
    title:'Snack Silicone Bag', cat:'Silicone Bags', price:'$12.99', was:'$15.99', save:'Save 19%',
    rating:'4.9', reviews:'2,156', img:'🥪', template:'bag',
    desc:'The ultimate multi-purpose reusable snack bag for snacks, diet portions, kids lunches, pet treats, makeup, personal items, and more -- microwave and oven safe. 100% platinum-cured silicone, plastic-free, odorless, flavorless. Loved by busy parents and kids. Accessible for people with hand disabilities. Available in 4 colors.',
    capacity:'2.5 cups / 22.2 oz / 630 grams / 1.38 lbs', dimensions:'H: 4in x W: 2in x L: 7in (10.16cm x 5.08cm x 17.78cm)', weight:'0.23 lbs / 3.8 oz / 95 grams', temp:'Microwave and oven safe',
    colors:'Light Pink, Light Baby Blue, Light Lemon Yellow, Clear',
    features:['Microwave & Oven Safe -- heat snacks and full meals directly in the bag','Multi-Purpose -- snacks, kids lunches, pet treats, makeup, diet portions','100% Platinum-Cured Silicone -- plastic-free, odorless, flavorless','Patented Secure Seal -- keeps contents fresh and protected','Two Large Easy-to-Carry Handles -- stands upright for hassle-free storage','Accessible Design -- easy for individuals with hand disabilities','4 Fun Colors -- Light Pink, Light Baby Blue, Light Lemon Yellow, Clear','Eco-Friendly -- help protect our oceans by cutting down on plastic waste'],
    care:'Dishwasher safe top rack. Hand-wash with warm soapy water. Open fully to clean all corners. Store flat. Safe for all food types.'
  },
  'tall-bag': {
    title:'Tall Silicone Bag (Lunch Bag / Sous-Vide)', cat:'Silicone Bags', price:'$19.99', was:'$24.99', save:'Save 20%',
    rating:'4.9', reviews:'687', img:'📏', template:'bag',
    desc:'A one-of-a-kind lunch bag for home chefs and packed lunches alike. Fits 1 sandwich, 1 fruit (apple or orange), 1 can of soda or water bottle, and a cookie as a snack. 100% platinum-cured silicone, microwave and oven safe. Features a storage date calendar, braille measurements, and patented one-hand design. Rated (E) for Everyone.',
    capacity:'1.0 Liter | As lunch bag: 1 sandwich + 1 fruit + 1 soda or water bottle + 1 snack | Grains: 3.3 lbs / 52.8 oz / 6.2 cups | Fruits: 2.5 lbs / 40 oz / 5 cups | Cherries: 2.1 lbs / 33.6 oz | Grapes: 2.0 lbs / 32 oz', dimensions:'H: 8.5in x W: 2.0in x L: 6.0in (21.59cm x 5.08cm x 15.24cm)', weight:'0.28 lbs / 4.4 oz / 125 grams', temp:'Microwave and oven safe',
    colors:'White/Clear, Light Lemon Yellow, Light Baby Blue, Light Pink',
    features:['Perfect Lunch Bag -- fits 1 sandwich, 1 fruit (apple or orange), 1 soda or water bottle, 1 cookie','Sous-Vide & Sandwich Bag -- precision cooking and everyday lunches in one bag','Storage Date Calendar -- printed on the side so food freshness is always tracked','Braille Measurements -- accessible for visually impaired users','Patented One-Hand Opening -- rated (E) for Everyone','Microwave & Oven Safe -- pure platinum-cured silicone with no plastic','1.0 Liter Capacity -- grains, fruits, sandwiches and more'],
    care:'Dishwasher safe top rack. Hand-wash with warm soapy water. The tall design makes every corner easy to reach. Store flat or rolled.'
  },
  'sousvide-bag': {
    title:'Sous-Vide Silicone Bag', cat:'Silicone Bags', price:'$22.99', was:'$28.99', save:'Save 21%',
    rating:'4.9', reviews:'843', img:'🥩', template:'bag',
    desc:'Engineered for precision cooking. Shares the same premium dimensions as our Tall Bag but built for sous-vide performance. Airtight seal survives hours in hot water without degrading or leaching chemicals. Safe for freezing, microwaving, oven cooking, and pressure cookers. Features storage date calendar, braille measurements, and patented one-hand opening.',
    capacity:'1.0 Liter', dimensions:'H: 8.5in x W: 2.0in x L: 6.0in (21.59cm x 5.08cm x 15.24cm)', weight:'0.28 lbs / 4.4 oz / 125 grams', temp:'Freezer to 400F',
    colors:'White/Clear, Light Lemon Yellow, Light Baby Blue, Light Pink',
    features:['Engineered for Sous-Vide -- airtight seal survives hours at precision cooking temperature','Safe to 400F -- no chemical leaching at high heat unlike plastic bags','100% Platinum-Cured Silicone -- plastic-free, odorless, flavorless','Storage Date Calendar -- track food freshness on the side of the bag','Braille Measurements -- accessible for visually impaired users','Patented One-Hand Opening -- easy to seal under pressure','Freezer to Oven -- complete temperature versatility','Reusable for Life -- replaces dozens of single-use vacuum seal bags every year'],
    care:'Rinse immediately after sous-vide use while still warm. Wash with warm soapy water or top rack dishwasher. Inspect seal before each use. Do not use with sharp bones that could puncture silicone.'
  },
  'food-covers-6': {
    title:'Silicone Stretch Lids - Set of 6', cat:'Kitchen', price:'$14.99', was:'$19.99', save:'Save 25%',
    rating:'4.8', reviews:'1,432', img:'🍽', template:'bag',
    desc:'Keep food fresh the smart way. Our Silicone Stretch Lids Set of 6 gives you airtight covers for bowls, pots, cans, and containers of every shape. FDA and LFGB certified food-grade silicone. No BPA, no lead, no harmful chemicals. Stretchy enough to fit round, square, and oval containers. Reusable, eco-friendly -- no more foil or plastic wrap.',
    capacity:'6 lids sized 6.3cm, 9cm, 11cm, 13.5cm, 15.3cm, and 19cm', dimensions:'Set of 6 graduated sizes from 6.3cm to 19cm', weight:'Lightweight set', temp:'Freezer, microwave, and dishwasher safe',
    colors:'Translucent silicone',
    features:['6-Piece Set -- sizes 6.3, 9, 11, 13.5, 15.3, and 19cm covers every bowl size','FDA & LFGB Certified -- non-toxic food-grade quality approved','Airtight Seal -- stretchy lids lock in freshness and prevent spills','Fits Any Shape -- works on round, square, and oval containers','No BPA, No Lead -- 100% toxin-free and safe for all food contact','Eco-Friendly -- eliminates foil, plastic wrap, and single-use covers','Wear & Tear Resistant -- stretches thousands of times without cracking','Easy to Clean -- dishwasher safe or hand-wash'],
    care:'Dishwasher safe all racks. Hand-wash with warm soapy water. Naturally antimicrobial silicone. Store flat or stack nested. Pull from edges to remove from containers.'
  },
  'food-covers-14': {
    title:'Silicone Stretch Lids - Set of 14', cat:'Kitchen', price:'$28.99', was:'$36.99', save:'Save 22%',
    rating:'4.8', reviews:'892', img:'🍽', template:'bag',
    desc:'The biggest set on the market. 14 silicone stretch lids -- 2 of each size -- give you complete coverage for every container in your kitchen from the smallest can to the largest stockpot. FDA and LFGB certified. No BPA, no lead, no harmful chemicals. The ultimate plastic-free kitchen upgrade.',
    capacity:'14 lids: 6.5, 9.5, 11.5, 14.5, 16.5, 21, and 24cm (2 of each size)', dimensions:'Set of 14 graduated sizes from 6.5cm to 24cm', weight:'Lightweight set', temp:'Freezer, microwave, and dishwasher safe',
    colors:'Translucent silicone',
    features:['14-Piece Set -- BIGGEST SET on the market: 6.5, 9.5, 11.5, 14.5, 16.5, 21, and 24cm (2 of each)','FDA & LFGB Certified -- non-toxic food-grade quality approved','Covers Everything -- from a small can up to a large stockpot','Airtight Seal -- stretchy lids lock in freshness and eliminate spills','Fits Any Shape -- round, square, and oval containers all covered','No BPA, No Lead -- 100% toxin-free for all food contact','Eco-Friendly -- completely eliminates foil, plastic wrap, and disposable covers','Professional Grade -- wear and tear resistant stretch silicone built to last'],
    care:'Dishwasher safe all racks. Hand-wash with warm soapy water. Naturally antimicrobial silicone. Store flat or stack nested by size. Pull from edges to remove.'
  },
  'collapsible-cup': {
    title:'Collapsible Silicone Cup (White) - 16 oz', cat:'Cups', price:'$12.99', was:null, save:null,
    rating:'4.9', reviews:'1,256', img:'☕', template:'cup',
    desc:"The world's first 100% silicone collapsible cup -- patented worldwide. Premium platinum-catalyzed silicone, FDA and LFGB certified. The innovative bottom folds into itself for compact carry. Makes ice cubes, bakes directly in cup, two drinking nozzles (sip or straw), spill-proof lid. Measurement lines inside. Microwave, oven, dishwasher, and freezer safe. 16 oz. Unbreakable.",
    capacity:'16 oz', dimensions:'Standard cup height / Folds to compact size for carry', weight:'Lightweight', temp:'Microwave, oven, dishwasher, and freezer safe',
    colors:'White',
    features:["World's First 100% Silicone Collapsible Cup -- patented worldwide, zero plastic components",'FDA & LFGB Certified -- premium platinum-catalyzed silicone, flavorless and odorless','Folds Into Itself -- bottom collapses for compact carry, always holds its shape','Makes Ice Cubes -- fill with water, freeze, pull body up to pour drink over ice','Bake Directly In the Cup -- oven safe for cooking and baking','Two Drinking Nozzles -- one for sipping, one for straws; one closes when the other is open','Spill-Proof Lid -- stays closed even if the cup is accidentally dropped','Measurement Lines Inside -- track fluid ounces as you pour','16 oz Capacity -- coffee, tea, smoothies, juice and more','Unbreakable -- perfect for beach, camping, travel, and everyday use'],
    care:'Dishwasher safe top rack. Hand-wash with warm soapy water. Collapse fully to clean all folds. Microwave and oven safe. Store collapsed flat.'
  },
  'pink-cup': {
    title:'Silicone Cup - Pink or White (Non-Collapsible) - 16 oz', cat:'Cups', price:'$14.99', was:null, save:null,
    rating:'4.9', reviews:'892', img:'🥤', template:'cup',
    desc:"The world's first 100% silicone non-collapsible cup -- patented worldwide. Available in pink and white. Premium platinum-catalyzed silicone, FDA and LFGB certified. Makes ice cubes, bakes directly in cup, two drinking nozzles, spill-proof lid. Measurement lines inside. Microwave, oven, dishwasher, and freezer safe. 16 oz. Unbreakable.",
    capacity:'16 oz', dimensions:'Standard cup dimensions', weight:'Lightweight', temp:'Microwave, oven, dishwasher, and freezer safe',
    colors:'Pink, White',
    features:["World's First 100% Silicone Non-Collapsible Cup -- patented worldwide, zero plastic components",'FDA & LFGB Certified -- premium platinum-catalyzed silicone, flavorless and odorless','Available in Pink & White -- non-toxic food-safe colorants that never fade or chip','Makes Ice Cubes -- fill with water, freeze, pour favorite drink over ice','Bake Directly In the Cup -- oven safe for cooking and baking','Two Drinking Nozzles -- one for sipping, one for straws; one closes when the other is open','Spill-Proof Lid -- stays closed even if the cup is dropped','Measurement Lines Inside -- track fluid ounces as you pour','16 oz Capacity -- coffee, tea, smoothies, juice, and more','Unbreakable -- drop-proof silicone ideal for beach and everyday use'],
    care:'Dishwasher safe top rack. Hand-wash with warm soapy water. Color is baked into the silicone and will not fade or chip. Microwave and oven safe.'
  },
  'shower-filter': {
    title:'Carbon Block Shower Filter', cat:'Water Filtration', price:'$39.00', was:'$54.00', save:'Save 28%',
    rating:'4.9', reviews:'1,847', img:'🚿', template:'water',
    desc:'Our flagship 12-layer coconut shell carbon block shower filter removes chlorine, chloramines, microplastics down to 5 microns, and heavy metals. Restores Vitamin C, Tourmaline, Germanium, and Calcium Sulfite. Eliminates chemical smell and skin irritation. Fits any standard shower arm -- no tools. 6-month cartridge life.',
    capacity:'Standard 1/2 inch NPT -- fits virtually all shower arms', dimensions:'4.5in x 2.5in', weight:'12 oz', temp:'Up to 120F water',
    features:['12-Layer Coconut Shell Carbon Block -- highest quality filtration material','Removes Chlorine & Chloramines -- eliminates chemical smell and skin irritation','Filters Microplastics to 5 Microns -- stops plastic particles before they reach your skin','Removes Heavy Metals -- lead, mercury, arsenic significantly reduced','Restores Vitamin C, Tourmaline, Germanium & Calcium Sulfite -- beneficial minerals','Easy Installation -- fits any standard 1/2 inch NPT shower arm, no tools required','6-Month Cartridge Life -- replace every 6 months for optimal performance'],
    care:'Install hand-tight onto shower arm with teflon tape. Replace cartridge every 6 months or when flow rate decreases. Wipe exterior with damp cloth. Do not submerge housing.'
  },
  'fridge-filter': {
    title:'Alkaline Refrigerator Filter', cat:'Water Filtration', price:'$59.00', was:'$74.00', save:'Save 20%',
    rating:'4.8', reviews:'623', img:'🧊', template:'water',
    desc:'pH-balanced, microplastic-free water from your refrigerator. Independently lab tested. Raises pH to 7.5-8.5 alkaline range. Removes chlorine, chloramines, lead, mercury, and arsenic. Compatible with Samsung DA29-00020B, HAF-CIN, DA29-00020A, and DA29-00003G. Installs in under 2 minutes.',
    capacity:'Samsung Compatible', dimensions:'Varies by model', weight:'8 oz', temp:'Refrigerator temperature',
    features:['Raises pH to 7.5-8.5 Alkaline Range -- cleaner crisper tasting water','Removes Microplastics -- independently lab tested and verified','Samsung Compatible -- fits DA29-00020B, HAF-CIN, DA29-00020A, DA29-00003G','Removes Chlorine & Chloramines -- dramatically improves taste','Removes Lead, Mercury, Arsenic -- heavy metal reduction verified','Easy 2-Minute Install -- no tools, same swap as OEM filter','6-Month Filter Life -- same replacement schedule as factory filters'],
    care:'Replace every 6 months or 300 gallons. Flush 2 gallons after installation before drinking. Store replacement filters in cool dry place away from sunlight.'
  },
  'faucet-filter': {
    title:'Faucet Mount Filter', cat:'Water Filtration', price:'$34.00', was:'$42.00', save:'Save 19%',
    rating:'4.8', reviews:'412', img:'🚰', template:'water',
    desc:'Pure filtered water from any standard kitchen faucet. Coconut shell carbon block removes chlorine, lead, and microplastics. Toggle between filtered and unfiltered with a single flip. No tools -- installs in under 5 minutes. High flow rate with no pressure drop.',
    capacity:'Universal Fit -- standard US kitchen faucets', dimensions:'3.2in x 2.1in', weight:'9 oz', temp:'Up to 100F water',
    features:['Universal Fit -- works with standard US kitchen faucets','One-Click Toggle -- switch between filtered and unfiltered instantly','Coconut Shell Carbon Block -- same premium technology as our shower filter','Removes Chlorine, Lead & Microplastics -- independently verified','No Tools Required -- installs in under 5 minutes','High Flow Rate -- no pressure drop','6-Month Cartridge Life -- easy to replace'],
    care:'Install hand-tight onto faucet. Flush 2 gallons after installation. Replace cartridge every 6 months. Clean exterior with damp cloth. Do not use with water above 100F.'
  },
  'alkaline-system': {
    title:'Alkaline Water System', cat:'Water Filtration', price:'$79.00', was:'$99.00', save:'Save 20%',
    rating:'4.9', reviews:'318', img:'💎', template:'water',
    desc:'Premium under-counter alkaline water system with dedicated faucet. Multi-stage filtration with coconut shell carbon block. Mineral-rich pH-balanced water on demand. Removes 99%+ chlorine, lead, mercury, and arsenic. pH output 7.5-9.0.',
    capacity:'Under-Counter', dimensions:'10in x 5in x 14in', weight:'3.2 lbs', temp:'Up to 100F water',
    features:['Multi-Stage Filtration -- 5 stages from sediment to alkaline mineral enhancement','Dedicated Faucet Included -- clean separate tap for filtered water only','pH 7.5-9.0 Output -- adjustable alkaline water on demand','Removes 99%+ Chlorine -- dramatically improves taste and odor','Removes Lead, Mercury, Arsenic -- heavy metal reduction lab verified','Coconut Shell Carbon Block -- premium filtration at the core','Under-Counter Install -- hidden professional appearance','6-Month Filter Life -- easy cartridge replacement'],
    care:'Professional installation recommended. Flush system 10 minutes after first install. Replace all filters every 6 months. Annual sanitization recommended. Keep area dry and ventilated.'
  },
  'shower-combo': {
    title:'Shower Head + Filter Combo', cat:'Shower', price:'$79.00', was:'$110.00', save:'Save 28%',
    rating:'4.9', reviews:'742', img:'💧', template:'water',
    desc:'The complete solution. Premium chrome shower head with our 12-layer coconut shell carbon block filter built directly in. One install. Removes chlorine, microplastics, and heavy metals. Restores beneficial minerals. 3 GPM eco-flow. Multiple spray patterns. Replaces any standard shower arm in minutes.',
    capacity:'3 GPM', dimensions:'4.5in shower head + 4.5in filter unit', weight:'1.8 lbs', temp:'Up to 120F water',
    features:['All-In-One Design -- shower head and filter in a single premium unit','12-Layer Carbon Block -- same filter as our standalone shower filter','3 GPM Eco-Flow -- powerful pressure while conserving water','Premium Chrome Finish -- matches any bathroom decor','Removes Chlorine, Microplastics & Heavy Metals -- full filtration','Restores Vitamin C, Tourmaline, Germanium & Calcium Sulfite','Multiple Spray Patterns -- massage, mist, rainfall, and full coverage','6-Month Filter Life -- replace cartridge, keep the head forever'],
    care:'Install hand-tight onto shower arm with teflon tape. Replace filter cartridge every 6 months. Clean with mild soap and soft cloth. No abrasive cleaners on chrome finish.'
  },
  'shower-head': {
    title:'Premium Chrome Shower Head', cat:'Shower', price:'$45.00', was:'$59.00', save:'Save 24%',
    rating:'4.8', reviews:'389', img:'🚿', template:'water',
    desc:'High-pressure premium chrome shower head with eco-flow design. Multiple spray patterns. 3 GPM. Designed to pair perfectly with any ITPC carbon block filter for the ultimate clean shower. Standard 1/2 inch NPT connection fits any shower arm.',
    capacity:'3 GPM', dimensions:'4.5in diameter head', weight:'1.2 lbs', temp:'Up to 120F water',
    features:['Premium Chrome Finish -- polished mirror shine, tarnish resistant','3 GPM High-Pressure Flow -- powerful shower without wasting water','Multiple Spray Patterns -- rainfall, massage, mist, and combination','Pairs with ITPC Filters -- designed to work with our carbon block system','Easy Installation -- standard 1/2 inch NPT connection, no tools needed','Adjustable Angle -- pivot head for perfect positioning','Universal Fit -- replaces any standard shower arm'],
    care:'Clean with mild soap and soft cloth. Remove mineral deposits with white vinegar. No abrasive cleaners or steel wool. Wipe dry after cleaning to maintain chrome finish.'
  }
};
// -- LOAD PRODUCT INTO TEMPLATE -----------------------------------------
function loadProduct(productId) {
  var p = allProducts[productId];
  if (!p) return;

  var pageId = p.template === 'water' ? 'page-product-water' :
               p.template === 'cup'   ? 'page-product-cup'   : 'page-product';

  document.querySelectorAll('.page').forEach(function(pg) { pg.classList.remove('active'); });
  var page = document.getElementById(pageId);
  if (page) page.classList.add('active');

  function set(sel, val) {
    var el = page ? page.querySelector(sel) : null;
    if (el && val != null) el.textContent = val;
  }
  function setHTML(sel, val) {
    var el = page ? page.querySelector(sel) : null;
    if (el && val != null) el.innerHTML = val;
  }

  set('.pdp-cat', p.cat);
  set('.pdp-title', p.title);
  set('.pdp-price', p.price);
  set('.pdp-desc-short', p.desc);

  var imgEl = page ? page.querySelector('.pdp-main-img') : null;
  if (imgEl) imgEl.textContent = p.img;

  var wasEl = page ? page.querySelector('.pdp-price-was') : null;
  if (wasEl) wasEl.textContent = p.was || '';

  var saveEl = page ? page.querySelector('.pdp-save-tag') : null;
  if (saveEl) saveEl.textContent = p.save || '';

  if (p.reviews) set('.pdp-rating-text a', p.reviews + ' verified reviews');
  if (p.rating) set('.pdp-stars', p.rating >= 4.5 ? '★★★★★' : '★★★★☆');

  var bc = page ? page.querySelector('.pdp-breadcrumb .current') : null;
  if (bc) bc.textContent = p.title;

  // -- Fill Description tab --
  var descTab = page ? page.querySelector('[id$="-desc"], #tab-desc, #tab-water-desc, #tab-cup-desc') : null;
  if (!descTab && page) {
    var allContents = page.querySelectorAll('.pdp-tab-content');
    if (allContents.length > 0) descTab = allContents[0];
  }
  if (descTab && p.desc) {
    descTab.innerHTML = '<h3>' + p.title + '</h3><p>' + p.desc + '</p>' +
      (p.capacity ? '<p><strong>Capacity:</strong> ' + p.capacity + '</p>' : '') +
      (p.dimensions ? '<p><strong>Dimensions:</strong> ' + p.dimensions + '</p>' : '') +
      (p.temp ? '<p><strong>Temperature Range:</strong> ' + p.temp + '</p>' : '');
  }

  // -- Fill Features tab --
  var featTab = page ? page.querySelector('[id$="-features"], [id$="-removes"], #tab-features') : null;
  if (!featTab && page) {
    var allContents = page.querySelectorAll('.pdp-tab-content');
    if (allContents.length > 1) featTab = allContents[1];
  }
  if (featTab && p.features) {
    var featHTML = '<h3>Key Features</h3><ul>';
    for (var i = 0; i < p.features.length; i++) {
      var parts = p.features[i].split('--');
      featHTML += '<li><strong>' + parts[0].trim() + '</strong>' +
        (parts[1] ? ' -- ' + parts[1].trim() : '') + '</li>';
    }
    featHTML += '</ul>';
    featTab.innerHTML = featHTML;
  }

  // -- Fill Specs tab --
  var specsTab = page ? page.querySelector('[id$="-specs"], #tab-specs, #tab-water-specs, #tab-cup-specs') : null;
  if (!specsTab && page) {
    var allContents = page.querySelectorAll('.pdp-tab-content');
    if (allContents.length > 2) specsTab = allContents[2];
  }
  if (specsTab) {
    var specsHTML = '<h3>Technical Specifications</h3><div class="pdp-specs-grid">';
    if (p.capacity) specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">Capacity</span><span class="pdp-spec-value">' + p.capacity + '</span></div>';
    if (p.dimensions) specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">Dimensions</span><span class="pdp-spec-value">' + p.dimensions + '</span></div>';
    if (p.weight) specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">Weight</span><span class="pdp-spec-value">' + p.weight + '</span></div>';
    if (p.temp) specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">Temperature Range</span><span class="pdp-spec-value">' + p.temp + '</span></div>';
    specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">Material</span><span class="pdp-spec-value">' + (p.template === 'water' ? 'Coconut Shell Carbon Block' : 'Platinum-Cured Silicone') + '</span></div>';
    specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">BPA Free</span><span class="pdp-spec-value">Yes -- 100%</span></div>';
    specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">FDA Compliant</span><span class="pdp-spec-value">Yes</span></div>';
    specsHTML += '<div class="pdp-spec"><span class="pdp-spec-label">Price</span><span class="pdp-spec-value">' + p.price + (p.was ? ' (was ' + p.was + ')' : '') + '</span></div>';
    specsHTML += '</div>';
    specsTab.innerHTML = specsHTML;
  }

  // -- Fill Care tab --
  var careTab = page ? page.querySelector('[id$="-care"], [id$="-install"], #tab-care, #tab-water-install, #tab-cup-care') : null;
  if (!careTab && page) {
    var allContents = page.querySelectorAll('.pdp-tab-content');
    if (allContents.length > 3) careTab = allContents[3];
  }
  if (careTab && p.care) {
    careTab.innerHTML = '<h3>Care & Instructions</h3><p>' + p.care + '</p>';
  }

  // Reset tabs to show first tab
  if (page) {
    page.querySelectorAll('.pdp-tab').forEach(function(t) { t.classList.remove('active'); });
    page.querySelectorAll('.pdp-tab-content').forEach(function(c) { c.classList.remove('active'); });
    var firstTab = page.querySelector('.pdp-tab');
    var firstContent = page.querySelector('.pdp-tab-content');
    if (firstTab) firstTab.classList.add('active');
    if (firstContent) firstContent.classList.add('active');
  }

  window.scrollTo({top: 0, behavior: 'smooth'});
}

// -- SHOP CARD CLICKS (data-product-id) --------------------------------
document.querySelectorAll('.prod-card[data-product-id]').forEach(function(card) {
  card.addEventListener('click', function(e) {
    if (e.target.classList.contains('add-to-cart')) return;
    var id = this.getAttribute('data-product-id');
    if (id) loadProduct(id);
  });
});

// -- BUILD YOUR OWN BUNDLE ---------------------------------------------
var byobItems = {
  gallon:    {name:'Gallon Bag',         price:18.99},
  halfgallon:{name:'Half Gallon Bag',    price:15.99},
  snack:     {name:'Snack Bag',          price:12.99},
  tall:      {name:'Tall Bag',           price:19.99},
  sousvide:  {name:'Sous-Vide Bag',      price:22.99},
  cup:       {name:'Collapsible Cup',    price:12.99},
  covers:    {name:'Food Covers 6pk',    price:14.99},
  covers14:  {name:'Food Covers 14pk',   price:28.99},
  shower:    {name:'Shower Filter',      price:39.00},
  fridge:    {name:'Fridge Filter',      price:59.00}
};
var byobTierData = [{min:3,pct:10},{min:5,pct:15},{min:8,pct:20},{min:12,pct:25}];
var byobCart = {};

function byobChange(id, delta) {
  var current = byobCart[id] || 0;
  var next = Math.max(0, Math.min(99, current + delta));
  if (next === 0) { delete byobCart[id]; } else { byobCart[id] = next; }
  byobRender();
}

function byobRender() {
  // Count totals
  var totalItems = 0;
  var subtotal = 0;
  var ids = Object.keys(byobCart);
  for (var i = 0; i < ids.length; i++) {
    var qty = byobCart[ids[i]];
    totalItems += qty;
    if (byobItems[ids[i]]) subtotal += byobItems[ids[i]].price * qty;
  }

  // Update qty numbers and minus buttons
  var allIds = Object.keys(byobItems);
  for (var i = 0; i < allIds.length; i++) {
    var id = allIds[i];
    var numEl = document.getElementById('byob-num-' + id);
    var minusEl = document.getElementById('byob-btn-minus-' + id);
    if (numEl) numEl.textContent = byobCart[id] || 0;
    if (minusEl) minusEl.disabled = !byobCart[id];
  }

  // Find current tier
  var currentTier = null;
  for (var i = byobTierData.length - 1; i >= 0; i--) {
    if (totalItems >= byobTierData[i].min) { currentTier = byobTierData[i]; break; }
  }
  var discountPct = currentTier ? currentTier.pct : 0;
  var discountAmt = subtotal * (discountPct / 100);
  var total = subtotal - discountAmt;

  // Update tier highlights
  var tierEls = document.querySelectorAll('#byob-tiers .byob-tier');
  for (var i = 0; i < tierEls.length; i++) {
    var min = parseInt(tierEls[i].getAttribute('data-min'));
    tierEls[i].classList.toggle('unlocked', totalItems >= min);
    tierEls[i].classList.toggle('active', currentTier !== null && min === currentTier.min);
  }

  // Update cart list
  var cartList = document.getElementById('byob-cart-list');
  if (cartList) {
    if (totalItems === 0) {
      cartList.innerHTML = '<div class="byob-cart-empty">Add products on the left to get started -></div>';
    } else {
      var html = '';
      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];
        var item = byobItems[id];
        if (!item) continue;
        var qty = byobCart[id];
        html += '<div class="byob-cart-item">' +
          '<span class="byob-cart-item-name">' + item.name + '</span>' +
          '<span class="byob-cart-item-qty">x' + qty + '</span>' +
          '<span class="byob-cart-item-price">$' + (item.price * qty).toFixed(2) + '</span>' +
          '<button class="byob-cart-item-remove" onclick="byobChange(\'' + id + '\',-99)">x</button>' +
        '</div>';
      }
      cartList.innerHTML = html;
    }
  }

  // Update progress bar
  var progressMsg = document.getElementById('byob-progress-msg');
  var progressFill = document.getElementById('byob-progress-fill');
  if (progressMsg && progressFill) {
    var nextTier = null;
    for (var i = 0; i < byobTierData.length; i++) {
      if (totalItems < byobTierData[i].min) { nextTier = byobTierData[i]; break; }
    }
    if (nextTier) {
      var needed = nextTier.min - totalItems;
      var prevMin = currentTier ? currentTier.min : 0;
      var pct = prevMin === nextTier.min ? 100 : Math.round(((totalItems - prevMin) / (nextTier.min - prevMin)) * 100);
      progressMsg.innerHTML = 'Add <strong>' + needed + ' more item' + (needed > 1 ? 's' : '') + '</strong> to unlock ' + nextTier.pct + '% off';
      progressFill.style.width = pct + '%';
    } else {
      progressMsg.innerHTML = '<strong>Maximum savings unlocked! 25% off your bundle.</strong>';
      progressFill.style.width = '100%';
    }
  }

  // Update totals
  var totalsEl = document.getElementById('byob-totals');
  var subtotalEl = document.getElementById('byob-subtotal');
  var discountRow = document.getElementById('byob-discount-row');
  var discountLbl = document.getElementById('byob-discount-label');
  var discountEl = document.getElementById('byob-discount');
  var totalEl = document.getElementById('byob-total');
  var ctaEl = document.getElementById('byob-cta');

  if (totalsEl) totalsEl.style.display = totalItems > 0 ? 'block' : 'none';
  if (subtotalEl) subtotalEl.textContent = '$' + subtotal.toFixed(2);
  if (discountRow) discountRow.style.display = discountPct > 0 ? 'flex' : 'none';
  if (discountLbl) discountLbl.textContent = discountPct + '% Bundle Discount';
  if (discountEl) discountEl.textContent = '-$' + discountAmt.toFixed(2);
  if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
  if (ctaEl) {
    ctaEl.disabled = totalItems === 0;
    ctaEl.textContent = totalItems === 0
      ? 'Add at least 1 item to continue'
      : 'Add Bundle to Cart (' + totalItems + ' item' + (totalItems > 1 ? 's' : '') + ')';
  }
}

function byobAddAll() {
  var ids = Object.keys(byobCart);
  var totalItems = 0;
  for (var i = 0; i < ids.length; i++) totalItems += byobCart[ids[i]];
  if (totalItems === 0) return;
  for (var i = 0; i < totalItems; i++) addToCart();
  var ctaEl = document.getElementById('byob-cta');
  if (ctaEl) {
    ctaEl.textContent = 'Added to Cart!';
    ctaEl.style.background = 'var(--fern)';
    ctaEl.disabled = true;
  }
  setTimeout(function() {
    if (ctaEl) {
      ctaEl.textContent = 'Add Bundle to Cart';
      ctaEl.style.background = '';
      byobRender();
    }
  }, 2500);
}

// -- FREE SHIPPING PROGRESS BAR ---------------------------------------
var cartTotal = 0;
var FREE_SHIP = 40;
function updateShippingBar() {
  var bar = document.getElementById('shippingProgress');
  var fill = document.getElementById('shippingBarFill');
  var msg = document.getElementById('shippingMsg');
  if (!bar) return;
  if (cartTotal <= 0) return;
  bar.classList.add('show');
  document.body.classList.add('has-shipping-bar');
  var pct = Math.min(100, (cartTotal / FREE_SHIP) * 100);
  if (fill) fill.style.width = pct + '%';
  if (msg) {
    if (cartTotal >= FREE_SHIP) {
      msg.innerHTML = '<strong>You qualify for FREE SHIPPING!</strong>';
      bar.style.background = 'var(--fern)';
    } else {
      var remaining = (FREE_SHIP - cartTotal).toFixed(2);
      msg.innerHTML = 'Add <strong>$' + remaining + '</strong> more for FREE SHIPPING';
    }
  }
}

// Override addToCart to also update shipping bar
var _origAddToCart = addToCart;
addToCart = function() {
  cartTotal += 15;
  _origAddToCart();
  updateShippingBar();
};

// -- LIVE SALES NOTIFICATIONS -----------------------------------------
var _salesData = [
  {name:'Sarah from Texas',    product:'Gallon Silicone Bag',       img:'grn'},
  {name:'David from California',product:'Carbon Block Shower Filter',img:'water'},
  {name:'Maria from Florida',  product:'Mixed Kitchen Bundle',       img:'grn'},
  {name:'James from New York', product:'Collapsible Cup',            img:'grn'},
  {name:'Emily from Ohio',     product:'Half Gallon Bag',            img:'grn'},
  {name:'Robert from Washington',product:'Tall Bag',                 img:'grn'},
  {name:'Lisa from Oregon',    product:'Shower Head + Filter Combo', img:'water'},
  {name:'Michael from Arizona',product:'Snack Bag',                  img:'grn'},
  {name:'Jessica from Colorado',product:'Pink Bundle (3pc)',         img:'grn'},
  {name:'Daniel from Georgia', product:'Alkaline Fridge Filter',     img:'water'}
];
var _salesEmoji = ['grn','grn','grn','grn','grn','grn','water','water','grn','water'];
var _salesIdx = 0;
var _salesTimes = ['just now','1 minute ago','2 minutes ago','3 minutes ago','5 minutes ago'];

function showSalesNotif() {
  var item = _salesData[_salesIdx % _salesData.length];
  _salesIdx++;
  var notif = document.getElementById('salesNotif');
  if (!notif) return;
  var imgEl = document.getElementById('salesNotifImg');
  var nameEl = document.getElementById('salesNotifName');
  var prodEl = document.getElementById('salesNotifProduct');
  var timeEl = document.getElementById('salesNotifTime');
  var emojis = {grn:'🥗', water:'🚿'};
  if (imgEl) { imgEl.textContent = emojis[item.img] || '🥗'; imgEl.className = 'sales-notif-img ' + item.img; }
  if (nameEl) nameEl.textContent = item.name + ' just bought';
  if (prodEl) prodEl.textContent = item.product;
  if (timeEl) timeEl.textContent = _salesTimes[Math.floor(Math.random() * _salesTimes.length)];
  notif.classList.add('show');
  setTimeout(function() { notif.classList.remove('show'); }, 5500);
}
setTimeout(function() {
  showSalesNotif();
  setInterval(function() {
    if (Math.random() > 0.3) showSalesNotif();
  }, 24000);
}, 8000);

// -- EXIT INTENT POPUP ------------------------------------------------
var _exitShown = false;
function showExitPopup() {
  if (_exitShown) return;
  _exitShown = true;
  var el = document.getElementById('exitPopup');
  if (el) el.classList.add('show');
}
function closeExitPopup() {
  var el = document.getElementById('exitPopup');
  if (el) el.classList.remove('show');
}
function submitExitPopup() {
  var emailEl = document.getElementById('exitEmail');
  if (!emailEl) return;
  var val = emailEl.value.trim();
  if (!val || val.indexOf('@') < 0) { emailEl.style.borderColor = '#B52020'; return; }
  var form = document.getElementById('exitPopupForm');
  var success = document.getElementById('exitPopupSuccess');
  if (form) form.style.display = 'none';
  if (success) success.classList.add('show');
}
document.addEventListener('mouseleave', function(e) {
  if (e.clientY <= 0) showExitPopup();
});
setTimeout(function() { showExitPopup(); }, 45000);

// -- SHIPPING + PRIVACY NAV --------------------------------------------
// Already handled by .page-link data-page in footer


// -- COLOR PICKER FUNCTIONS -----------------------------------------------
function pickColor(swatch, groupId) {
  var row = swatch.parentElement;
  var siblings = row.querySelectorAll('.cswatch');
  for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('active');
  swatch.classList.add('active');
  var label = document.getElementById(groupId + '-selected');
  if (label) label.textContent = swatch.getAttribute('data-color');
}

function pickByobColor(swatch, productId) {
  var row = swatch.parentElement;
  var siblings = row.querySelectorAll('.byob-cswatch');
  for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('active');
  swatch.classList.add('active');
  var label = document.getElementById('byob-color-' + productId);
  if (label) label.textContent = swatch.getAttribute('data-color');
}


// -- SEARCH PRODUCTS -------------------------------------------------------
function searchProducts(val) {
  var s = document.getElementById('searchSuggestions');
  if (!s) return;
  var q = (val || '').trim().toLowerCase();
  if (!q) { s.classList.remove('show'); return; }
  var matches = [];
  for (var id in allProducts) {
    var p = allProducts[id];
    if (p.title.toLowerCase().indexOf(q) !== -1 || p.cat.toLowerCase().indexOf(q) !== -1) {
      matches.push({id: id, p: p});
      if (matches.length >= 7) break;
    }
  }
  if (!matches.length) { s.classList.remove('show'); return; }
  var html = '';
  for (var i = 0; i < matches.length; i++) {
    var id = matches[i].id, p = matches[i].p;
    html += '<div class="search-suggestion" onmousedown="loadProduct(\'' + id + '\');document.getElementById(\'navSearch\').value=\'\';document.getElementById(\'searchSuggestions\').classList.remove(\'show\')">' +
      '<span class="ss-img">' + p.img + '</span>' +
      '<span class="ss-info"><strong>' + p.title + '</strong><span class="ss-price">' + p.price + '</span></span>' +
    '</div>';
  }
  s.innerHTML = html;
  s.classList.add('show');
}

